export const colors = {
    success: "#28a745",
    warning: "#ffc107",
    danger: "#e95c6d",
    info: "#17a2b8",
    primary: "#ec6726",
    primaryLight: "#f3953f",
    primaryDark: "#d15d20",
    orangeSenne: "#F3953F",
    secondary: "#b9bd5c",
    secondaryDark: "#abb056",
    unabled: "#dadada",
    unabledDark: "#c6c6c6",
    greenButton: "#198754",
    grayDark: "#343A40",
    blueSenne: "#0DCAF0",
    cinzaCard: "#D7D7D7",
    cinzaBg: "#F7F8FC",
    black50: "#00000080",
    orangeSenneSecundary: "#EC6726",

    // Carlão palette
    carlaoTextDark: "#1e2328",
    carlaoTextMuted: "#6b7280",
    carlaoTextLight: "#9ca3af",
    carlaoBorderLight: "#d1d5db",
    carlaoTeal: "#0ea5e9",
};

export const colorsHover = {
    success: "#218838", // darkened 15%
    warning: "#e0a800", // darkened 15%
    danger: "#c82333", // darkened 15%
    info: "#138496", // darkened 15%
    primary: "#c85720", // darkened 15% assumption
    primaryDark: "#e56623", // lightened 15% assumption (original was darken primaryDark? No, original was lighten 15% for dark?)
    // Let's stick to standard darken/lighten logic or hardcoded values if we want to be precise.
    // Original SCSS: color.adjust($primaryDark, $lightness: 15%)
    primaryLight: "#cf7f36", // darkened 15%
    secondary: "#9da14e", // darkened 15%
    secondaryDark: "#c3c862", // lightened 15%
    unabled: "#b9b9b9", // darkened 15%
    unabledDark: "#e0e0e0", // lightened 15%
    orangeHover: "#FDEFE2",
};

export const colorsFont = {
    success: "white",
    warning: "white",
    danger: "white",
    info: "white",
    primary: "white",
    primaryDark: "white",
    primaryLight: "white",
    secondary: "white",
    secondaryDark: "white",
    unabled: "white",
    unabledDark: "white",
};
